<template>

    <div class="counter">
        <span class="count">{{ count | numeral('0.[0]a') }}</span>
        <span v-if="label" class="label">{{ label }}</span>
    </div>

</template>

<style scoped lang="scss">

    .counter {
        @include font-medium(16px);
        border-right: 1px solid $color-bg;
        color: $color-text;
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        line-height: 1.6em;
        padding: 15px 15px 15px 0;
        text-align: center;
        width: 80px;
        .label {
            @include font-medium(12px);
            margin: 0;
        }
    }

</style>

<script>

export default {

    props: {
        count: {
            type: Number,
            default: 0,
        },
        label: {
            type: String,
            default: null,
        },
    },

}

</script>
